export const commodityConstants = {
    COMMODITY_FETCHING: 'COMMODITY_FETCHING',
    COMMODITY_FETCHED: 'COMMODITY_FETCHED',
    COMMODITY_SUBMITTED: 'COMMODITY_SUBMITTED',
    COMMODITY_SUBMITTING: 'COMMODITY_SUBMITTING',
    COMMODITIES: 'COMMODITIES',
    COMMODITY: 'COMMODITY',
    RESET: 'RESET',
}